import { createSelector } from '@ngrx/store';
import { filter, flatMap, some } from 'lodash';

import { Role } from '@lockton-apps/shared/interfaces';
import { T2CodesSelectors } from '@lockton-apps/shared/data-access/t2-codes';

import { selectAuthenticatedUser } from './auth-user.selectors';

export const selectAuthenticatedUserT2Codes = createSelector(
  selectAuthenticatedUser,
  T2CodesSelectors.selectAllT2Codes,
  (authenticatedUser, t2Codes) => {
    if (
      !authenticatedUser ||
      !(
        authenticatedUser.role === Role.Broker ||
        authenticatedUser.role === Role.LeadBroker
      )
    ) {
      return t2Codes;
    }

    return filter(t2Codes, (t2Code) =>
      some(
        authenticatedUser.t2Codes,
        (t2CodeLite) => t2CodeLite.id === t2Code.id
      )
    );
  }
);

export const selectAuthenticatedUserCobs = createSelector(
  selectAuthenticatedUserT2Codes,
  (t2Codes) => flatMap(t2Codes, (t2Code) => t2Code.classOfBusinesses)
);
